export default {
  name: 'contract-management',
  translationKey: 'contract-management-module',
  routePrefix: 'contract-management',
  routeNamePrefix: 'admin.contract-management',
  directRoutesAvailable: false,
}
